import "react-id-swiper/src/styles/css/swiper.css";
import { styles } from "./QuotationsSlider.style";
import * as React from "react";
import { Typography, withStyles, WithStyles } from "@material-ui/core";

import { User } from "../../models/User.model";
import { Customer } from "../../types/Customer";
import { Quotation } from "../../types/Quotation";

import HomeSwiper from "../HomeSwiper/HomeSwiper";
import QuotationCard from "../QuotationCard/QuotationCard";
import { ActionHistory } from "../../types/ActionHistory";

type QuotationsItem = {
    quotation: Quotation;
    customer: Customer;
};

interface QuotationsListProps {
    advisor: User;
    quotations?: QuotationsItem[];
    onActionPerformed(quotation: Quotation, actionHistory: ActionHistory, customerId: string);
}

class QuotationsSlider extends React.Component<QuotationsListProps & WithStyles<typeof styles>> {

    public render() {

        const { classes, advisor, quotations } = this.props;

        return (
            <div className={classes.container}>
                <Typography variant="display1">Mes dernières propositions</Typography>
                <HomeSwiper slides={3}>
                    {this.renderList(quotations, advisor)}
                </HomeSwiper>
            </div>
        );
    }

    private renderList(quotations: QuotationsItem[], advisor: User) {
        return quotations.map((item, index) => (
            <div key={item.quotation.id || index}>
                <QuotationCard
                    advisor={advisor}
                    quotation={item.quotation}
                    customer={item.customer}
                    onActionPerformed={(quotation: Quotation, actionHistory: ActionHistory) => this.onActionPerformed(quotation, actionHistory, item.customer)}
                />
            </div>
        ));
    }

    private onActionPerformed(quotation: Quotation, actionHistory: ActionHistory, customer: Customer) {
        if (this.props.onActionPerformed && customer) {
            this.props.onActionPerformed(quotation, actionHistory, customer.id);
        }
    }

}

export default withStyles(styles)(QuotationsSlider);


// WEBPACK FOOTER //
// ./src/components/QuotationsSlider/QuotationsSlider.tsx